import React from 'react'

function Header() {
  return (
    <div className='Header'>
        <h1>Yummy<span>.</span></h1>
    </div>
  )
}

export default Header;